// Shared Font Awesome icon registry for Astral components.
// Domain mappings return these semantic names, never raw Font Awesome classes.
const ASTRAL_ICON_CLASSES = {
  arrowLeft: 'fa-light fa-arrow-left',
  arrowRight: 'fa-light fa-arrow-right',
  arrowUp: 'fa-light fa-arrow-up',
  arrowDown: 'fa-light fa-arrow-down',
  arrowsRotate: 'fa-light fa-arrows-rotate',
  building: 'fa-light fa-building',
  calendarDay: 'fa-light fa-calendar-day',
  calendarPlus: 'fa-light fa-calendar-plus',
  call: 'fa-sharp fa-solid fa-phone',
  check: 'fa-light fa-check',
  chevronDown: 'fa-light fa-chevron-down',
  chevronRight: 'fa-light fa-chevron-right',
  clear: 'fa-sharp fa-solid fa-xmark',
  closeAlternate: 'fa-sharp fa-light fa-xmark',
  clearOthers: 'fa-light fa-filter-circle-xmark',
  download: 'fa-light fa-download',
  ellipsis: 'fa-thin fa-ellipsis',
  edit: 'fa-light fa-pen',
  email: 'fa-sharp fa-solid fa-envelope',
  excel: 'fa-light fa-file-excel',
  eye: 'fa-light fa-eye',
  eyeSlash: 'fa-light fa-eye-slash',
  externalLink: 'fa-light fa-square-arrow-up-right',
  file: 'fa-sharp fa-light fa-file',
  imageBroken: 'fa-regular fa-image-slash',
  inbox: 'fa-light fa-inbox',
  checkboxChecked: 'fa-light fa-square-check',
  checkboxUnchecked: 'fa-light fa-square',
  lock: 'fa-light fa-lock',
  listCheck: 'fa-light fa-list-check',
  mail: 'fa-sharp fa-solid fa-envelope',
  pdf: 'fa-sharp fa-light fa-file-pdf',
  plus: 'fa-sharp fa-regular fa-plus',
  print: 'fa-light fa-print',
  question: 'fa-thin fa-circle-question',
  search: 'fa-light fa-magnifying-glass',
  settings: 'fa-light fa-gear',
  sms: 'fa-light fa-mobile-screen-button',
  screwdriverWrench: 'fa-light fa-screwdriver-wrench',
  trash: 'fa-thin fa-trash-can',
  warning: 'fa-light fa-triangle-exclamation',
  upload: 'fa-light fa-arrow-down-to-bracket',
} as const;

// A small number of legacy/domain glyphs have no suitable Font Awesome equivalent.
// Keep them explicit so consumers can render an asset intentionally rather than
// treating an asset path as a CSS class.
const ASTRAL_ICON_ASSETS = {
  translate: 'assets/icons/translate.svg',
} as const;

export type AstralIconName = keyof typeof ASTRAL_ICON_CLASSES;
export type AstralIconAssetName = keyof typeof ASTRAL_ICON_ASSETS;

export function resolveAstralIconClass(icon: string | null | undefined): string | null {
  if (!icon) {
    return null;
  }

  return ASTRAL_ICON_CLASSES[icon as AstralIconName] ?? icon;
}

export function resolveAstralIconAsset(icon: AstralIconAssetName): string {
  return ASTRAL_ICON_ASSETS[icon];
}
